module.exports = __webpack_public_path__ + "images/1337-b3bf88e4dda8fcd8aa3b8147f50e6d91.png";